// @flow
import React, { createContext, useContext } from 'react';
import type { Node, Ref } from 'react';

type Context = $ReadOnly<{
    width: number,
    paperRef: Ref
}>;

const SidebarContext = createContext<Context>({});

type Props = $ReadOnly<{
    width: number,
    paperRef: Ref,
    children: Node
}>;

export const SidebarProvider = ({ width, paperRef, children }: Props) => {
    const context = {
        width,
        paperRef
    };

    return (
        <SidebarContext.Provider value={context}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebarContext = () => useContext(SidebarContext);

export const useSidebarWidth = () => {
    const context = useSidebarContext();
    return context.width;
};

export const useSidebarPaperRef = () => {
    const context = useSidebarContext();
    return context.paperRef;
};